<script setup lang="ts">
import { RouterView } from 'vue-router';
import { onMounted } from 'vue';
import { useAppStore } from '@/stores/app.store';
import { ScrollArea, ScrollBar } from './components/ui/scroll-area';
import { Toaster } from '@/components/ui/sonner';
import CommandPalette from '@/components/core/CommandPalette.vue';

onMounted(() => {
    useAppStore().initTheme();
});
</script>

<template>
    <ScrollArea class="h-screen">
        <router-view v-slot="{ Component }">
            <transition name="fade" mode="out-in">
                <component :is="Component" />
            </transition>
        </router-view>
        <ScrollBar class="z-50" />
    </ScrollArea>
    <Toaster />
    <!-- Global overlays, mounted beside the router view so the palette is
         reachable on every route and at widths where the sidebar is hidden. -->
    <CommandPalette />
</template>
